import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_icon = _resolveComponent("s-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["service__item-card row items-center", { 'service__item-card--mobile': _ctx.isMobile }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToService && _ctx.goToService(...args)))
  }, [
    _createVNode(_component_s_icon, {
      name: _ctx.getIconName(),
      size: "80",
      class: "s-pl-lg s-pr-md col-auto",
      onClick: _ctx.goToService
    }, null, 8, ["name", "onClick"]),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.getServiceName), 1)
  ], 2))
}